import { initDatePickers } from '../../../../../../Packages/Plugins/Avency.Neos.FormDatePicker/Resources/Private/Assets/JavaScript/DatePicker.ts';

window.addEventListener('DOMContentLoaded', () => {
    
});

(function (window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        initDatePickers();
    });
})(window, document, window.PageLoadedQueue);
